{
  "commerce": {
    "aiChatView": {
      "errorPausedDetail": "Die KI ist in einem Abo enthalten. Öffne Einstellungen → Abrechnung, um eins abzuschließen."
    },
    "billingPage": {
      "title": "Abrechnung"
    },
    "paywallGate": {
      "errorOpenBilling": "Abrechnung konnte nicht geöffnet werden. Versuch es noch einmal.",
      "lapsedDescription": "Verlängere dein Abo, um deine Unterkunft weiter zu verwalten: 30 € pro Einheit und Monat, KI inklusive.",
      "pastDue": "Zahlung fehlgeschlagen. Aktualisiere deine Zahlungsmethode, um den Zugang zu behalten.",
      "startTrial": "{days} Tage kostenlos testen",
      "subscribe": "Abonnieren",
      "subscribeDescription": "Du hast deinen kostenlosen Testzeitraum bereits genutzt. Schließ ein Abo ab, um deine Unterkunft weiter zu verwalten: 30 € pro Einheit und Monat, KI inklusive.",
      "subscribeTitle": "Vidimo abonnieren",
      "trialAddPaymentMethod": "Füge eine Zahlungsmethode hinzu, um den Zugang zu behalten.",
      "trialDescription": "Teste Vidimo {days} Tage kostenlos, ohne Zahlungsdaten. Danach 30 € pro Einheit und Monat, KI inklusive.",
      "trialTitle": "Kostenlosen Testzeitraum starten"
    },
    "propertySettingsView": {
      "billingDescription": "Abo, KI-Nutzung und Zahlungsmethode",
      "billingTitle": "Abrechnung"
    },
    "subscriptionGate": {
      "aiIncluded": "KI-Funktionen sind in deinem Abo enthalten.",
      "aiTitle": "KI",
      "errorGeneric": "Etwas ist schiefgelaufen",
      "errorLoad": "Abrechnung konnte nicht geladen werden",
      "manageSubscription": "Abo verwalten",
      "status": {
        "active": "Aktiv",
        "past_due": "Zahlung überfällig",
        "trialing": "Testzeitraum"
      },
      "subscribe": "Abonnieren",
      "subscribePrice": "30 € pro Einheit und Monat, abgerechnet nach Anzahl der Einheiten in dieser Unterkunft. KI-Funktionen sind enthalten.",
      "subscribeTitle": "Abonnieren",
      "subscribedPrice": "30 € pro Einheit und Monat. Wenn du eine Einheit hinzufügst oder entfernst, passt sich deine Rechnung automatisch an.",
      "subscriptionTitle": "Abo"
    }
  }
}
